<template>
  <div style="height: 100%">
    <div>
      <el-form :model="formData" :rules="rules" ref="addEditForm" label-width="110px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="无活动报警" prop="alarmSwitch">
              <el-switch
                v-model="formData.alarmSwitch"
                active-value="1"
                inactive-value="0"
                active-text="开启"
                inactive-text="关闭">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="持续时长" prop="duration" v-if="formData.alarmSwitch === '1'">
              <el-input-number v-model="formData.duration"></el-input-number>
              <span class="unit">分钟</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 时间段设置 -->
        <el-row v-if="formData.alarmSwitch === '1'">
          <el-col :span="24">
            <el-form-item label="有效时间段" prop="timeRanges">
              <div>
                <el-time-picker v-fixZoom style="width: 220px;" is-range v-model="timeVal" format="HH:mm" value-format="HH:mm:ss" :clearable="false"
                                range-separator="至" start-placeholder="开始" end-placeholder="结束" placeholder="选择时间范围">
                </el-time-picker>
                <el-button type="primary" @click="addTime()">添加</el-button>
              </div>
              <div style="height: 30px;color: #1A1A1A;font-size: 16px" v-for="(item, index) in formData.timeRanges" :key="index">
                <span>时段{{ index + 1 }}：</span><span>{{ item.time[0] }} - {{ item.time[1] }}</span>
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-minus"
                  circle
                  @click="delTime(item)"
                  class="remove-btn">
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="height: 60px;margin: 0px 30px 0">
      <el-row>
        <el-col :span="12"><div class="cancel-btn" @click="closeActivity"><span>取消</span></div></el-col>
        <el-col :span="12"><div class="send-btn" @click="submitLocation('addEditForm')"><span>确定</span></div></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {sendcommand} from '../../../api/device'

export default {
  name: 'noActivity',
  props: {
    listObj: {
      type: Object,
      default: null
    },
    commandObj: {
      type: String
    }
  },
  data () {
    return {
      deviceRow: {},
      // 表单数据
      formData: {
        alarmSwitch: '0', // 开关状态，'0': 关闭, '1': 开启
        duration: 5, // 持续时间（分钟）
        timeRanges: [] // 时间段数组
      },
      // 表单验证规则
      rules: {
        alarmSwitch: [
          { required: true, message: '请选择无活动报警开关状态', trigger: 'change' }
        ],
        duration: [
          { required: true, message: '请输入持续时间', trigger: 'blur' }
        ]
      },
      timeVal: ['09:00:00', '18:00:00']
    }
  },
  created () {
    this.deviceRow = this.clone(this.listObj.deviceRow)
    this.getDeviceLocationData(this.commandObj)
  },
  methods: {
    getDeviceLocationData (commandObj) {
      if (commandObj) {
        this.formData.alarmSwitch = commandObj.command1.toString()
        this.formData.duration = commandObj.command2 / 60

        // 如果存在时间段设置，则解析
        if (commandObj.command3) {
          try {
            // 尝试解析 JSON 字符串
            const parsedTimeRanges = typeof commandObj.command3 === 'string'
              ? JSON.parse(commandObj.command3)
              : commandObj.command3

            if (Array.isArray(parsedTimeRanges)) {
              this.formData.timeRanges = parsedTimeRanges.map(range => ({
                time: [range.start, range.end]
              }))
            } else {
              this.formData.timeRanges = []
            }
          } catch (e) {
            console.error('解析时间段数据失败:', e)
            this.formData.timeRanges = []
          }
        } else {
          // 默认添加一个时间段
          this.formData.timeRanges = []
        }
      } else {
        // 默认添加一个时间段
        this.formData.timeRanges = []
      }
    },
    addTime () {
      if (this.timeVal.length === 0 || this.timeVal[0] === '') {
        this.$message.warning('请选择生效时间')
      } else {
        // 判断所选时间是否与timeRanges时间重叠
        for (let i = 0; i < this.formData.timeRanges.length; i++) {
          if (this.timeVal[0] >= this.formData.timeRanges[i].time[0] && this.timeVal[0] <= this.formData.timeRanges[i].time[1]) {
            this.$message.warning('所选时间段有重叠，请重新选择')
            return
          }
        }
        this.formData.timeRanges.push({
          time: this.timeVal
        })
      }
    },
    delTime (item) {
      // 删除时间段
      this.formData.timeRanges.splice(this.formData.timeRanges.indexOf(item), 1)
    },
    closeActivity () {
      this.$emit('closeOpen')
    },
    submitLocation (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.sendCommand('setisactivity')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendCommand (met) {
      const timeRanges = this.formData.timeRanges.map(range => {
        return {
          start: range.time[0],
          end: range.time[1]
        }
      })
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: met,
        command1: this.formData.alarmSwitch + '',
        command2: parseFloat(this.formData.duration) * 60 + '',
        command3: JSON.stringify(timeRanges) // 添加时间段设置
      }
      sendcommand(data).then(res => {
        this.$notify({ title: '成功', message: '成功设置设备', type: 'success', duration: 2000 })
        this.$emit('getCommandData')
        this.$emit('closeOpen')
      }).catch(() => {})
    },
    // 克隆对象的方法
    clone (obj) {
      return JSON.parse(JSON.stringify(obj))
    }
  }
}
</script>

<style scoped>

.unit {
  margin-left: 5px;
  color: #606266;
}

.time-ranges-container {
  width: 100%;
}

.time-range-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.time-range-item .el-time-picker {
  flex: 1;
  margin-right: 10px;
}

.remove-btn {
  margin-left: 10px;
}

.add-time-btn {
  margin-top: 10px;
}

.time-rules-tips {
  margin-top: 15px;
  padding: 0 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}

.time-rules-tips ul {
  margin: 5px 0;
  padding-left: 20px;
}

.time-rules-tips li {
  margin: 3px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/noActivity.vue